module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-12-2ba30ce627701a8db5b519a65a2ab1da.png";